import React from 'react';
import { IApplication } from '../types';

const TransferApplicationDeadlinePassedPage = ({ application }: { application: IApplication }) => (
  <div className="text-center p-5">
    <h2>Prazo encerrado</h2>
    <p>
      O prazo para envio dos documentos
      {application.submission_deadline ? ` encerrou em ${application.submission_deadline}` : ' foi encerrado'}.
      Não é mais possível enviar ou alterar documentos.
    </p>
    <p>Em caso de dúvida, entre em contato com a Secretaria.</p>
  </div>
);

export default TransferApplicationDeadlinePassedPage;
